<template>
  <div class="modal fade" id="partner" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      <h2>Sumate como Partner</h2>
      <p class="size-16">Asociate a Andalepite y hacé crecer tu negocio con un mercado inexplorado en tu ciudad.</p>
      <form class="form modal-form">
        <div class="row">
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <div class="form-group">
              <label>Nombre</label>
              <input type="text" v-model="dataForm.nombre" class="form-control"/>
              <span class="label label-danger" v-if="!$v.dataForm.nombre.required && mostrarErrores">Campo requerido</span>
            </div>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <div class="form-group">
              <label>Apellido</label>
              <input type="text" v-model="dataForm.apellido" class="form-control"/>
              <span class="label label-danger" v-if="!$v.dataForm.apellido.required && mostrarErrores">Campo requerido</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <div class="form-group">
              <label>Nombre de tu empresa</label>
              <input type="text" v-model="dataForm.nombreEmpresa" class="form-control"/>
              <span class="label label-danger" v-if="!$v.dataForm.nombreEmpresa.required && mostrarErrores">Campo requerido</span>
            </div>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <div class="form-group">
              <label>Tipo de cocina</label>
              <input type="text" v-model="dataForm.tipoCocina" class="form-control"/>
              <span class="label label-danger" v-if="!$v.dataForm.tipoCocina.required && mostrarErrores">Campo requerido</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <div class="form-group">
              <label>Barrio o Zona</label>
              <input type="text" v-model="dataForm.barrio" class="form-control"/>
              <span class="label label-danger" v-if="!$v.dataForm.barrio.required && mostrarErrores">Campo requerido</span>
            </div>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <div class="form-group">
              <label>Web o fanpage de Facebook</label>
              <input type="text" v-model="dataForm.web" class="form-control"/>
              <span class="label label-danger" v-if="!$v.dataForm.web.url && mostrarErrores">Formato no válido (require url). Puede estar vacío</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <div class="form-group">
              <label>E-Mail</label>
              <input type="mail" v-model="dataForm.email" class="form-control"/>
              <span class="label label-danger" v-if="(!$v.dataForm.email.email || !$v.dataForm.email.required) && mostrarErrores">Formato no válido (require email).</span>
            </div>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <div class="form-group">
              <label>Teléfono</label>
              <input type="text" v-model="dataForm.telefono" class="form-control"/>
              <span class="label label-danger" v-if="!$v.dataForm.telefono.numeric && mostrarErrores">Formato no válido (require números).</span>
            </div>
          </div>
        </div>
        <div class="row text-center center-block">
          <vue-recaptcha 
            sitekey="6LfZAikUAAAAAOU_SNuSQG_-dF2mOiHV4XHqrpaF"
            @verify="onVerify"
          >
          </vue-recaptcha>
        </div>
        <div class="form-action">
          <button type="button" class="btn btn-fill" @click.prevent="clickEnviar">ENVIAR</button>
        </div>
      </form>
      </div>
    </div>
    </div>
  </div><!-- Fin modal partner-->
</template>
<script>
import {email, required, url, numeric} from 'vuelidate/lib/validators'
import VueRecaptcha from 'vue-recaptcha'
import $ from 'jquery'

export default {
  components: {
    VueRecaptcha
  },
  data () {
    return {
      mostrarErrores: false,
      dataForm: {
        respuestaCaptcha: null,
        nombre: '',
        apellido: '',
        nombreEmpresa: '',
        tipoCocina: '',
        barrio: '',
        web: '',
        email: '',
        telefono: ''
      }
    }
  },
  methods: {
    clickEnviar () {
      const me = this
      if (me.$v.dataForm.$invalid) {
        me.mostrarErrores = true
        return false
      }
      me.$http.post('/api/public/partner', me.dataForm).then(({body}) => {
        $('#partner').modal('hide')
        me.$emit('mostrar-notificacion', 'El mail se envió correctamente', 'success')
      }, (err) => {
        console.error(err)
      })
    },
    onVerify (response) {
      const me = this
      me.dataForm.respuestaCaptcha = response
    }
  },
  validations: {
    dataForm: {
      nombre: {
        required
      },
      apellido: {
        required
      },
      nombreEmpresa: {
        required
      },
      tipoCocina: {
        required
      },
      barrio: {
        required
      },
      web: {
        url
      },
      email: {
        required,
        email
      },
      telefono: {
        numeric
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ModalPartner.vue?10612571